


















































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import GenericModal from "@/components/agroGenericModal/AgroGenericModal.vue";

@Component({
  name: "CarSelectModal",
  components: {
    CarModal: GenericModal,
  },
  filters: {
     replaceComma(value: number) {
      if (!value) {
        return "";
      }
      const convertedArea = Number(value);
      const final = convertedArea.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 1,
        })
        return (final.replace(/[,.]/g, finalValue => (finalValue === ',' ? '.' : ',')));
    },
  },
})
export default class CarSelectModal extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly isVisible!: boolean;
  @Prop({ type: Array, default: () => [] }) private farmsList!: any[];

  get maxArea() {
    return 45000;
  }

  @Emit("oncancel")
  private cancel() {}

  selectedItem(farm: any) {
    this.$emit("onSelectedItem", farm);
    this.cancel();
  }
}
